/* eslint-disable */
import cx from 'classnames';
import React, { Component } from 'react';
import { Link } from 'react-router'
import { Helmet } from "react-helmet";
import { browserHistory } from 'react-router';
import { connect } from 'react-redux'
import { Col, Row, Grid, Navbar, Nav, NavItem, Breadcrumb, Glyphicon, Modal } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Elements, StripeProvider, CardElement, injectStripe } from 'react-stripe-elements';
import { NotificationContainer } from 'react-notifications';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import './Wrapper.css';
import 'react-notifications/lib/notifications.css';
import { url, authHeader, jsonAndStatus, newOrder, navTo, mapDispatch, setToken } from '../utils/util';
import { STRIPE_KEY } from '../config';
import {
  register,
  login,
  fetchUser,
  forgotPassword,
} from '../actions';
import RegisterForm from './partials/RegisterForm';
import LoginForm from './partials/LoginForm';
import OmniField from './partials/OmniField';

import Routes from '../routes';


class Wrapper extends OzComponent {

  static need = [
    ['user', fetchUser, () => { return [{ silent: true}] } ],
  ];

  data = {
    'home': ['Home', '/'],
  };

  state = {
    stripe: null,
  };

  pathname() {
    return '/';
  }

  componentDidMount() {
    try {
      this.setState({ stripe: window.Stripe(STRIPE_KEY) });
    } catch(e) {}
    this.props.fetchUser({ silent: true });
  }

  isNotLoggedInPath() {
    let path = this.pathname();
    return (path === '/' || path === '/login' || path === '/register');
  }

  toggleDesktopHamburger() {
    this.setState({ desktopHamburger: !this.state.desktopHamburger });
  }

  renderNavbar() {
    let userButtons;
    let i = 0;

    let desktopHamburger = (
      <NavItem className="desktop-hamburger-wrapper">
        <FontAwesome onClick={() => this.toggleDesktopHamburger()} name="bars" />
        <div className={cx('desktop-hamburger', { show: this.state.desktopHamburger })}>
          <Link className="link" to={'/leaderboard'}>Leaderboard</Link>
        </div>
      </NavItem>
    );

    let hasListings = this.props.isLoggedIn && this.props.user.profile.companies.length > 0;
    if (this.props.isLoggedIn) {
      userButtons = (
        <Nav pullRight>
          {!hasListings && <li className="navbar-link"><a href="https://marcellortutay.typeform.com/to/nqynTW">Add Room</a></li>}
          <LinkContainer className="navbar-link phone-only" key="leaderboard" to={'/leaderboard'}><NavItem>Leaderboard</NavItem></LinkContainer>
          <LinkContainer className="navbar-link" key="top" to={'/top'}><NavItem>Top Rooms</NavItem></LinkContainer>
          {hasListings && <LinkContainer className="navbar-link" key="manage" to={'/pro/rooms'}><NavItem>Your Listings</NavItem></LinkContainer>}
          <LinkContainer className="navbar-link" key="account" to={'/p/' + this.props.user.username}><NavItem>{this.props.user.username}</NavItem></LinkContainer>
          {desktopHamburger}
        </Nav>
      );
    } else {
      userButtons = (
        <Nav pullRight>
          {/*<LinkContainer className="navbar-link" key="map" to={'/map'}><NavItem>Escape Room Map</NavItem></LinkContainer>*/}
          {!hasListings && <li className="navbar-link"><a href="https://marcellortutay.typeform.com/to/nqynTW">Add Room</a></li>}
          <LinkContainer className="navbar-link phone-only" key="leaderboard" to={'/leaderboard'}><NavItem>Leaderboard</NavItem></LinkContainer>
          <LinkContainer className="navbar-link" key="about" to={'/about'}><NavItem>About Us</NavItem></LinkContainer>
          <LinkContainer className="navbar-link" key="top" to={'/top'}><NavItem>Top Rooms</NavItem></LinkContainer>
          <NavItem eventKey={1} onClick={() => this.showLogin()}>Sign In</NavItem>
          <NavItem eventKey={2} onClick={() => this.showRegister()}>Sign Up</NavItem>
          {desktopHamburger}
        </Nav>
      );
    }
    // let body = (
    //   <Nav pullRight>
    //     {this.renderLeftNavNodes((url, onClick, body) => {
    //       if (url) {
    //         return <LinkContainer className="navbar-link" key={i} to={url}><NavItem eventKey={i++}>{body}</NavItem></LinkContainer>;
    //         // return <Link className="navbar-link" key={i} to={url}><NavItem eventKey={i++}>{body}</NavItem></Link>;
    //         // return <div>{url}</div>
    //       } else {
    //         return <NavItem key={i} eventKey={i++} onClick={onClick}>{body}</NavItem>;
    //       }
    //      })}
    //   </Nav>
    // );

    let crumbs = this.props.crumbs || ['home'];
    let last = null;
    for (let i = crumbs.length - 2; i >= 0 && !last; i--) {
      last = this.data[crumbs[i]];
    }

    return (
      <Navbar staticTop collapseOnSelect>
        <Navbar.Header>
          {last &&
           <div className="backbutton">
           <Glyphicon glyph="chevron-left" /> <Link to={last[1]}>{last[0]}</Link>
           </div>}

           <Link to={'/'}><div className="logo">
             <div className="dark-part">escape</div>
             <div className="dark-part-box">escape</div>
             <div className="light-part">spy</div>
             <div className="logo-img"><img alt="magnifying glass" src="https://escapespy.s3-us-west-2.amazonaws.com/misc/glass.svg"/></div>
           </div></Link>

           <div className="omni-wrapper">
             <OmniField />
           </div>

          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          {userButtons}
        </Navbar.Collapse>
      </Navbar>
    );
  }

  renderBreadcrumbs() {
    let nodes = []
    let crumbs = this.props.crumbs || ['home'];
    for (let i = 0 ; i <= crumbs.length; i++) {
      let d = this.data[crumbs[i]];
      if (d && i < crumbs.length - 1) {
        nodes.push(<Breadcrumb.Item key={i}><Link to={d[1]}>{d[0]}</Link></Breadcrumb.Item>);
      } else if (d && i === crumbs.length - 1) {
        nodes.push(<Breadcrumb.Item key={i} active>{d[0]}</Breadcrumb.Item>);
      } else if (i === crumbs.length - 1) {
        nodes.push(<Breadcrumb.Item key={i} active>{crumbs[i]}</Breadcrumb.Item>);
      } else if (crumbs[i]) {
        nodes.push(<Breadcrumb.Item key={i}><Link to={crumbs[i].href}>{crumbs[i].text}</Link></Breadcrumb.Item>);
      }
    }

    return (
      <div>
        <div className="breadcrumbs"><Breadcrumb>{nodes}</Breadcrumb></div>
      </div>
    );
  }

  renderLeftNavNodes(fn) {
    let buttons = [
      // ['/locations', 'Locations'],
      // ['/rooms', 'Rooms'],
    ];

    let nodes = buttons.map(button => {
      let url = button[0];
      let text = button[1];
      let onClick = button[2];

      let active = ((url !== '/' && this.pathname().startsWith(url))
          || (url === '/' && this.pathname() === '/'));
      if (active && url === '/sv') {
        active = this.pathname() == '/sv';
      }
      if (fn) {
        return fn(url, onClick, text);
      } else {
        let body = <div className={cx('btn-left-nav', {'active': active})}>{text}</div>;
        return (
          <div key={url}>
            {url && <Link to={url}>{body}</Link>}
            {!url && <div onClick={onClick}>{body}</div>}
          </div>
        );
      }
    });

    return nodes;
  }

  renderLoading() {
    return (
      <div className="loading-wrapper" style={{ position: 'fixed', textAlign: 'center', width: '100%' }}>
        <div style={{ position: 'absolute' }} className="loading"><img alt="Loading" src="https://s3-us-west-2.amazonaws.com/misc-cdn/loading_222.svg"/></div>
      </div>
    );
  }

  register(e, values) {
    e.preventDefault();
    console.log('register with values:', values);
    this.props.register(values)
      .then(resp => {
        console.log('Register resp:', resp);
        if (!resp.error) {
          return this.props.login({
            username: values.username,
            password: values.password,
          });
        }
      })
      .then(resp => {
        if (!resp.error) {
          console.log('setting token after register', resp);
          setToken(resp.token);
          this.props.fetchUser()
            .then(() => this.closeRegister());
        }
      });

  }

  showRegister() {
    this.setState({ registering: true });
  }

  closeRegister() {
    this.setState({ registering: false });
  }

  renderRegister() {
    return (
      <Modal show={!!this.state.registering}>
        <Modal.Header closeButton onHide={() => this.closeRegister()}>
          <Modal.Title>Sign Up</Modal.Title>
        </Modal.Header>
        <RegisterForm
          doRegister
          values={{}}
          modal={true}
          errors={this.props.errors.register}
          buttonText="Sign Up"
          cancelText="Cancel"
          onSuccess={() => this.closeRegister()}
          onCancel={() => this.closeRegister()}
        />
      </Modal>
    );
  }

  login(e, values) {
    e.preventDefault();
    console.log('login with values:', values);
    if (values.forgot) {
      this.props.forgotPassword({ forgot: values.forgot })
        .then(resp => {
          if (resp.didSend) {
            this.closeLogin();
            alert('Sent email to ' + values.forgot);
          } else {
            alert("We couldn't find an account for " + values.forgot);
          }
        });
    } else {
      this.props.login(values)
        .then(resp => {
          console.log('login resp', resp);
          if (!resp.error) {
            console.log('setting token after login', resp);
            setToken(resp.token);
            window.location.href = '/';
          }
        })
    }
  }

  showLogin() {
    this.setState({ logining: true });
  }

  closeLogin() {
    this.setState({ logining: false });
  }

  renderLogin() {
    return (
      <Modal show={!!this.state.logining}>
        <Modal.Header closeButton onHide={() => this.closeLogin()}>
          <Modal.Title>Sign In</Modal.Title>
        </Modal.Header>
        <LoginForm
          values={{}}
          modal={true}
          errors={this.props.errors.login}
          buttonText="Sign In"
          cancelText="Cancel"
          onSubmit={(e, values) => this.login(e, values)}
          onCancel={() => this.closeLogin()}
        />
      </Modal>
    );
  }

  render() {
    let contentInner;
    if (this.props.pro) {
      let path;
      try {
        path = window.location.pathname;
      } catch(e) {
        path = '';
      }

      let dashboardPath = '/pro/manage';
      let proLinks = [
        // [dashboardPath, 'Dashboard'],
        ['/pro/rooms', 'Rooms'],
        ['/pro/leaderboards', 'Leaderboards'],
        ['/pro/gift-cards', 'Gift Cards'],
        ['/pro/integrations', 'Integrations'],
        // ['/pro/bookings', 'Bookings'],
        // ['/pro/widget', 'Widget'],
        // ['/pro/settings', 'Settings'],
      ];

      let nodes = proLinks.map(proLink => {
        let active = path.startsWith(proLink[0]) || !path && proLink[0] == dashboardPath;
        return (
          <Link className={cx('pro-nav-option', { active })} to={proLink[0]}>{proLink[1]}</Link>
        );
      });

      contentInner = (
        <div className="">
          <div className="pro-wrapper">
            <div className="pro-left-nav">
              {nodes}
            </div>
            <div className="content-inner pro-content">
              {this.props.children}
            </div>
          </div>
        </div>
      );
    } else {
      contentInner = (
        <div className="content-inner">
          {this.props.children}
        </div>
      );
    }

    let helmetTitle = 'EscapeSpy';
    if (this.props.helmet || this.props.title) {
      helmetTitle = (this.props.helmet || this.props.title) + ' - EscapeSpy';
    }

    return (
      <StripeProvider stripe={this.state.stripe}>
        <div className={'Wrapper ' + this.props.className}>
          <Helmet>
            <title>{helmetTitle}</title>
          </Helmet>

          <NotificationContainer />

          {this.props.loading && this.renderLoading()}

          {this.renderNavbar()}

          {this.renderRegister()}
          {this.renderLogin()}

          <Grid>
            <Row>
              <Col xs={12} md={12} lg={12}>
              <div className={cx('content', {'no-title': !this.props.title, padded: this.props.padded })}>
                {this.props.title && <div className="content-title">{this.props.title}</div>}
                {contentInner}
              </div>
            </Col>
            </Row>
          </Grid>

          {/*
          <div key="footer-el" className="es-footer">
            <div className="es-footer-brand"><Link to="/">escapespy</Link></div>
            <div className="es-footer-subtitle">find, book, track escape rooms.</div>
            <div className="es-footer-blurb">Find time slots for escape rooms all around the world, and see <b>real time availability</b> for all the rooms in your area. <b>Track your escapes</b> and share your times with your friends. Get ranked on our <b>global leaderboard</b>.</div>
          </div>
          */}
        </div>
      </StripeProvider>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.loading,
    loadingCount: state.loadingCount,
    errors: state.errors,
    user: state.user,
    activeJobs: state.activeJobs || [],
    isLoggedIn: state.isLoggedIn,
    view: state.view,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    login,
    fetchUser,
    forgotPassword,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Wrapper)



/** WEBPACK FOOTER **
 ** ./src/components/Wrapper.js
 **/